/**
 * Retorna o estilo CSS associado a um status judicial da fatura específico.
 *
 * @param {string} name - O nome do status de resumo da fatura.
 * @returns {string} O estilo CSS associado ao status de resumo da fatura.
 *
 * @example
 * const style = setJudicialStatusColor('[L0] Atrasadas');
 * console.log(style); // Output: 'width: 200px; color: #C40C0C;'
 */
export function setJudicialStatusColor(name) {
  const invoiceSummaryStatusColorMap = {
    '[L0] Atrasadas': 'width: 200px; color: #C40C0C;',
    '[L1] Cobrança Iniciada': 'width: 200px; color: #C40C0C;',
    '[L2] Retorno Negativo / Nulo': 'width: 200px; color: #C40C0C;',
    '[L3] Aguardo Fatura / Saldo Atual': 'width: 200px; color: #C40C0C;',
    '[L4] Aguardo Pagamento': 'width: 200px; color: #C40C0C;',
    '[L5] Relatório Energia': 'width: 200px; color: #C40C0C;',
    '[L6] Iniciar Notificações': 'width: 200px; color: #C40C0C;',
    '[L7] Acordo Quebrado': 'width: 200px; color: #C40C0C;',
    '[J0] Judicializar': 'width: 200px; color: #C96868;',
    '[G0] Notif. Amigável à Enviar': 'width: 200px; color: #C23C0C;',
    '[G1] Notif. Amigável Registrada': 'width: 200px; color: #C23C0C;',
    '[E0] Notif. Extrajudicial à Enviar': 'width: 200px; color: #FFB200',
    '[E1] Notif. Extrajudicial Registrada': 'width: 200px; color: #FFB200',
    '[S0] Serasa à Enviar': 'width: 200px; color: #FF6500;',
    '[S1] Serasa Registrado': 'width: 200px; color: #FF6500;',
    '[P0] Protesto à Enviar': 'width: 200px; color: #850F8D;',
    '[P1] Protesto Registrado': 'width: 200px; color: #850F8D;',
    '[M0] Ação Monit. à Enviar': 'width: 200px; color: #481E14;',
    '[M1] Ação Monit. Registrado': 'width: 200px; color: #481E14;',
    '[R0] Perda ou Prejuizo': 'width: 200px; color: #E49BFF;',
    '[D0] Acordo Informal': 'width: 200px; color: #378CE7;',
    '[D1] Acordo Assinado': 'width: 200px; color: #378CE7;',
  };
  return invoiceSummaryStatusColorMap[name];
}
